import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="note-2" maskId="round-filled-radius-0-stroke-1.5-IconNote2"><path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V14.5781C21 14.777 20.921 14.9678 20.7803 15.1085L15.1085 20.7803C14.9678 20.921 14.777 21 14.5781 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75ZM4.5 4.5V19.5H13V13.75C13 13.3358 13.3358 13 13.75 13H19.5V4.5H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote2;
